import type { FaireProductEntity } from "../../entity_types/product";

export const p_uywpx7k753: FaireProductEntity = {
  token: "p_uywpx7k753",
  type: "product",
  name: "Mahjong Joker Clip *PREORDER*",
  brandToken: "b_nz2gvy3u76",
  brandName: "Maker Megan",
  imageUrl:
    "https://cdn.faire.com/fastly/1defbe9d004ee14a5aeb7a6d5c3a30b03d3e8f13076566681eb21ff64ec97672.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/682bc284db6d6a81eca10d7a7ca66e86d4b10ed84895b5a088d187bf36758042.jpeg",
    "https://cdn.faire.com/fastly/920289f14a8990924a0880d56c7286cef47e85fee7c599f508da7f721713cc03.jpeg",
  ],
  priceDollars: 12,
  description:
    "This clip is a preorder item and will ship in 8-12 weeks.\n\nClips are made from cellulose acetate; a durable and eco-friendly material!\n\nHeight: 3.5” / Length: (from claw to side of clip): 2.25”\n\n**Any ready to ship items ordered alongside preorder items will be held for shipment until preorder items are ready to ship. Please place separate orders if you’d like your ready to ship items to ship within 3-5 business days, otherwise they will not ship for 8-12 weeks. Thank you!**\n\nPlease note that if there are any significant delays, you will receive an email update.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:38.522Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
